import { ReactNode } from 'react';

import s from './styles.module.scss';

function MetaText(
  props: { text: string } | { children: ReactNode },
): JSX.Element {
  if ('children' in props) {
    return <div className={s.metaText}>{props.children}</div>;
  }
  return <div className={s.metaText}>{props.text}</div>;
}

export default MetaText;
